import React from 'react';
import { Route } from 'react-router-dom';
import { RouterProvider } from '../../../hooks/useRouter';
import { UserTrackingProvider } from '../../../hooks/flags/useUserTracking';
import HeaderWithSingletonHooks from './HeaderWithHooks';

const OneHeaderMicroApp: React.FC<{ host?: string; detachedHeaderMode: boolean }> = ({
    host = '',
    detachedHeaderMode,
}) => (
    <Route>
        {routeProps => {
            return (
                <RouterProvider value={{ ...routeProps, host, disableClientsideNavigation: true }}>
                    <UserTrackingProvider>
                        <HeaderWithSingletonHooks detachedHeaderMode={detachedHeaderMode} />
                    </UserTrackingProvider>
                </RouterProvider>
            );
        }}
    </Route>
);

export default OneHeaderMicroApp;
